<div class="profile-page">
  <div class="col-12 div-padding md:col-10 md:col-offset-1">
    <div class="profile-header mb-6">
      <h2 class="page-title">{{ 'Profile.ProfileSettings' | translate }}</h2>
      <div class="yellow-line"></div>
      <div class="profile-sub-page">
        @if (customerProfileState$ | async; as customerProfileState) {
<div class="profile-form">
          <ng-container>
            <div class="col-12 div-padding flex">
              <div class="md:col-6">
                <span class="profile-text">{{ 'Profile.Email' | translate }}</span>
              </div>
              <div class="md:col-6">
                <span class="profile-text-value">{{ customerProfileState?.customerProfile?.aspNetUsers?.email }}</span>
              </div>
            </div>
            <div class="col-12 div-padding flex">
              <div class="md:col-6">
                <span class="profile-text">{{ 'Profile.FirstName' | translate }}</span>
              </div>
              <div class="md:col-6">
                <span class="profile-text-value">{{ customerProfileState?.customerProfile?.firstName }}</span>
              </div>
            </div>
            <div class="col-12 div-padding flex">
              <div class="md:col-6">
                <span class="profile-text">{{ 'Profile.LastName' | translate }}</span>
              </div>
              <div class="md:col-6">
                <span class="profile-text-value">{{ customerProfileState?.customerProfile?.lastName }}</span>
              </div>
            </div>
            <div class="col-12 div-padding flex">
              <div class="md:col-6">
                <span class="profile-text">{{ 'Profile.DoctorID' | translate }}</span>
              </div>
              <div class="md:col-6">
                <span class="profile-text-value">{{ customerProfileState?.customerProfile?.doctorId }}</span>
              </div>
            </div>
            <div class="col-12 div-padding flex">
              <div class="md:col-6">
                <span class="profile-text">{{ 'Profile.InstituteName' | translate }}</span>
              </div>
              <div class="md:col-6">
                <span class="profile-text-value">{{
                  customerProfileState?.customerOrganization?.organization?.name
                }}</span>
              </div>
            </div>
            <div class="col-12 div-padding flex">
              <div class="md:col-6">
                <span class="profile-text">{{ 'Profile.Title' | translate }}</span>
              </div>
              <div class="md:col-6">
                <span class="profile-text-value">{{
                  customerProfileState?.customerProfile?.medicalSpecialty?.name
                }}</span>
              </div>
            </div>
            <div class="col-12 div-padding flex">
              <div class="md:col-6">
                <span class="profile-text">{{ 'Profile.Address' | translate }}</span>
              </div>
              <div class="md:col-6">
                <span class="profile-address-text-value">{{ customerProfileState?.customerOrganizationAddress }} </span>
              </div>
            </div>
            <div class="col-12 div-padding flex">
              <div class="md:col-6">
                <span class="profile-text">{{ 'Profile.Country' | translate }}</span>
              </div>
              <div class="md:col-6">
                <span class="profile-text-value">
                  {{ getCountryName(customerProfileState?.customerOrganization?.organization?.countryId) }}
                </span>
              </div>
            </div>
            @if (countries$ | async; as countries) {
<form
             
              [formGroup]="profileInfoForm"
              (ngSubmit)="onProfileFormSubmit(customerProfileState, countries)"
              class="col-12 div-padding">
              <div class="col-12 div-padding flex">
                <div class="md:col-6 mt-3">
                  <span class="profile-text-phone">{{ 'Profile.Phone' | translate }}</span>
                </div>
                <div class="md:col-6 div-padding">
                  <div class="col-12 div-padding flex">
                    <div class="md:col-6">
                      <p-select id="countryCode"
                        formControlName="prefixPhoneNumber"
                        styleClass="w-full"
                        [options]="(countries$ | async) ?? []"
                        optionLabel="phoneNumberPrefixWithPlus"
                        optionValue="phoneNumberPrefix"
                        placeholder="{{ 'Order_Info.CountryCode' | translate }}" />
                      @if (
                          profileInfoForm.controls.prefixPhoneNumber.touched &&
                          profileInfoForm.controls.prefixPhoneNumber.hasError('required')
                        ) {
<small
                        class="text-danger"
                       >
                        {{ 'Profile.InvalidInput' | translate }}
                      </small>
}
                    </div>
                    <div class="md:col-6" style="padding-left: 5px">
                      <input
                        pInputText
                        id="phone"
                        formControlName="phoneNumber"
                        placeholder="{{ 'Profile.PhoneNumberFormat' | translate }}"
                        class="w-full" />
                      @if (
                          profileInfoForm.controls.phoneNumber.touched &&
                          profileInfoForm.controls.phoneNumber.hasError('required') &&
                          !profileInfoForm.controls.phoneNumber.hasError('pattern')
                        ) {
<small
                        class="text-danger"
                       >
                        {{ 'Profile.InvalidInput' | translate }}
                      </small>
}
                      @if (
                          profileInfoForm.controls.phoneNumber.touched &&
                          profileInfoForm.controls.phoneNumber.hasError('pattern')
                        ) {
<small
                        class="text-danger"
                       >
                        {{ 'Profile.InvalidInput' | translate }}
                      </small>
}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 div-padding flex mt-3">
                <div class="md:col-6">
                  <span class="profile-text">{{ 'Profile.EmailNotification' | translate }}</span>
                </div>
                <div class="md:col-6">
                  <span class="profile-text-value">{{ 'Profile.ReceiveEmailNotificationFor' | translate }}</span>
                </div>
              </div>
              <div class="col-12 div-padding flex mt-3">
                <div class="md:col-6">
                  <span class="profile-text"></span>
                </div>
                <div class="md:col-6">
                  <span class="profile-text-value">
                    @for (emailNotification of emailNotifications; track emailNotification) {
<div class="field-checkbox">
                      <p-checkbox formControlName="emailNotification"
                        inputId="emailNotification"
                        name="group"
                        [value]="emailNotification.checked"
                        [readonly]="true" />
                      <label for="emailNotification" class="ml-2">{{ emailNotification.name }}</label>
                    </div>
}
                  </span>
                </div>
              </div>
              <div class="col-12 div-padding flex">
                <div class="md:col-6">
                  <span class="profile-text"></span>
                </div>
                <div class="md:col-6">
                  <span class="profile-text-value">
                    <p-button label="{{ 'Profile.SaveSettings' | translate }}"
                      styleClass="p-button-rounded"
                      type="submit"
                      [disabled]="!profileInfoForm.valid"
                      [loading]="profileSaveInProgress" /></span>
                </div>
              </div>
            </form>
}
          </ng-container>

          <ng-container>
            <div class="w-full div-border"></div>
            <div class="col-12 div-padding flex">
              <div class="md:col-6">
                <h1 class="profile-text">
                  {{ 'Profile.ChangePassword' | translate }}
                </h1>
              </div>
              <div class="md:col-6">
                <span class="profile-text-value"></span>
              </div>
            </div>
            <form [formGroup]="changePasswordForm" (ngSubmit)="onChangePasswordFormSubmit()" class="col-12 div-padding">
              <div class="col-12 div-padding flex">
                <div class="md:col-6 mt-3">
                  <span class="profile-text">{{ 'Profile.OldPassword' | translate }}</span>
                </div>
                <div class="md:col-6 profile-text-value">
                  <app-custom-password formControlName="oldPassword" class="custom-component" />
                </div>
              </div>
              <div class="col-12 div-padding flex mt-4">
                <div class="md:col-6 mt-3">
                  <span class="profile-text">{{ 'Profile.NewPassword' | translate }}</span>
                </div>
                <div class="md:col-6 profile-text-value">
                  <app-custom-password formControlName="newPassword" class="custom-component" />
                  @if (
                      changePasswordForm.controls.newPassword.touched &&
                      changePasswordForm.controls.newPassword.hasError('passwordMatch')
                    ) {
<small
                    class="text-danger"
                   >
                    {{ 'Auth.MatchedCredentials' | translate }}
                  </small>
}
                </div>
              </div>
              <div class="col-12 div-padding flex mt-4">
                <div class="md:col-6">
                  <span class="profile-text"></span>
                </div>
                <div class="md:col-6">
                  <span class="profile-text-value">
                    <p-button type="submit"
                      label="{{ 'Profile.ChangePassword' | translate }}"
                      styleClass="p-button-outlined p-button-rounded"
                      [disabled]="!changePasswordForm.valid"
                      [loading]="passwordSaveInProgress" />
                  </span>
                </div>
              </div>
            </form>
          </ng-container>
        </div>
}
      </div>
    </div>
  </div>
</div>
